module.exports = __webpack_public_path__ + "static/10-834ead1847941335002bd33637e45f55.jpeg";